const Profile = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <defs>
        <clipPath id="a">
          <rect
            width="30"
            height="30"
            transform="translate(-0.333)"
            fill="#b2b2b2"
            stroke="#b2b2b2"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(0.333)">
        <g transform="translate(0.917 1.25)">
          <g transform="translate(0 0)">
            <path
              d="M24.562,5.487a.4.4,0,1,0-.648.483A12.823,12.823,0,0,1,13.63,26.452,12.822,12.822,0,0,1,4.564,4.564a12.822,12.822,0,0,1,18.006-.126.4.4,0,0,0,.563-.579,13.63,13.63,0,0,0-19.14,19.41A13.63,13.63,0,0,0,27.261,13.63,13.517,13.517,0,0,0,24.562,5.487Z"
              transform="translate(0 0)"
              fill="#b2b2b2"
              stroke="#b2b2b2"
              strokeWidth="0.3"
            />
          </g>
          <g transform="translate(10.133 6.297)">
            <path
              d="M193.794,118.277a3.479,3.479,0,1,0,3.479,3.479A3.483,3.483,0,0,0,193.794,118.277Zm0,6.15a2.671,2.671,0,1,1,2.671-2.671A2.674,2.674,0,0,1,193.794,124.427Z"
              transform="translate(-190.315 -118.277)"
              fill="#b2b2b2"
              stroke="#b2b2b2"
              strokeWidth="0.3"
            />
          </g>
          <g transform="translate(6.284 14.037)">
            <path
              d="M128.332,263.641h-6.223a4.089,4.089,0,0,0-2.54.887.4.4,0,1,0,.5.632,3.234,3.234,0,0,1,2.036-.711h6.223a3.273,3.273,0,0,1,3.269,3.269V269.7a.008.008,0,0,1-.008.008H129.78v-1.917a.4.4,0,0,0-.808,0v1.917h-7.413v-1.917a.4.4,0,0,0-.808,0v1.917h-1.9a.008.008,0,0,1-.008-.008v-1.983a3.271,3.271,0,0,1,.407-1.581.4.4,0,0,0-.707-.392,4.081,4.081,0,0,0-.508,1.973V269.7a.817.817,0,0,0,.816.816h12.746a.817.817,0,0,0,.816-.816v-1.983A4.082,4.082,0,0,0,128.332,263.641Z"
              transform="translate(-118.031 -263.641)"
              fill="#b2b2b2"
              stroke="#b2b2b2"
              strokeWidth="0.3"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Profile;
